import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
import { GetNewPlayerRequestsResponse } from "./models";

export const getRequests = async (body: { page: number, status: string, platformUser: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.get(`/api/requests?page=${body.page}&status=${body.status}&platformUser=${body.platformUser}`, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

export const setAsPendingPayment = async (body: { id: string, reason: string, amount: number }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.patch(`/api/requests/pendingpayment/${body.id}`, { reason: body.reason, amount: body.amount }, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}


export const approveRequest = async (body: { id: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.patch(`/api/requests/approve/${body.id}`, {}, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

export const rejectRequest = async (body: { id: string, reason: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.patch(`/api/requests/reject/${body.id}`, { reason: body.reason }, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

export const getTotalAmount = async ({ name }: { name: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.post(`/totalAmount`, { name }, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

export const attachPayment = async (body: { id: string, base64invoice: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.patch(`/api/requests/attach-payment/${body.id}`, { base64invoice: body.base64invoice }, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

export const getNewPlayerRequests = async (body: { page: number, status: string, email: string }): Promise<GetNewPlayerRequestsResponse | null> => {
    let config = getConfig()
    let result: GetNewPlayerRequestsResponse | null = null
    try {
        const response = await axios.get(`/api/requests/player-requests?page=${body.page}&status=${body.status}&email=${body.email}`, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

export const rejectUser = async (body: { id: string, reason: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.patch(`/api/requests/reject-user/${body.id}`, { reason: body.reason }, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

export const approveUserRequest = async (body: { id: string }): Promise<any | null> => {
    let config = getConfig()
    let result: any | null = null
    try {
        const response = await axios.patch(`/api/requests/approve-user/${body.id}`, {}, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}


export interface CheckPlayerResponse {
    exist: boolean
    msg: string
}
export const checkPlayerExists = async (body: { email: string, platformUser: string }): Promise<CheckPlayerResponse | null> => {
    let config = getConfig()
    let result: CheckPlayerResponse | null = null
    try {
        const response = await axios.get(`/api/requests/check-player?email=${body.email}&platformUser=${body.platformUser}`, config)
        result = response?.data
    } catch (error: any) {
        result = error;
    }

    return result
}

